module.exports = __webpack_public_path__ + "img/mirakl_mini.a50f190b.svg";